import type { ConfigType } from '@plone/registry';
import { toast } from 'react-toastify';

import installSettings from './config/settings';

// Keep error toasts visible until the user dismisses them, otherwise
// validation messages (e.g. Plone invariants on the shop edit form)
// disappear too quickly to be read.
const toastError = toast.error.bind(toast);
toast.error = (content, options) =>
  toastError(content, { autoClose: false, ...options });

function applyConfig(config: ConfigType) {
  installSettings(config);

  return config;
}

export default applyConfig;
